import { Reducer } from 'redux';
import { BookActionEnum, BookActions, IBookState } from '.';
import {
  IBook,
  IDocumentBookCode,
  IUpdateDocumentBookCodeResult,
} from '../../services';

export const initialState: IBookState = {
  loading: true,
  books: [] as IBook[],
  bookAndDocId: {} as IDocumentBookCode,
  exceptionMessage: '',
  message: '',
  updateDocumentBookCodeResult: {} as IUpdateDocumentBookCodeResult,
};

export const bookReducer: Reducer<IBookState, BookActions> = (
  state = initialState,
  action: BookActions
) => {
  switch (action.type) {
    case BookActionEnum.FetchBooks:
      return {
        ...state,
        loading: true,
      };
    case BookActionEnum.FetchBookSuccess:
      return {
        ...state,
        loading: false,
        books: action.state?.books,
      };
    case BookActionEnum.FetchBookFailed:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
    case BookActionEnum.FetchBookWithDocIdsByDocIds:
      return {
        ...state,
        loading: true,
      };
    case BookActionEnum.FetchBookWithDocIdsByDocIdsSuccess:
      return {
        ...state,
        loading: false,
        bookAndDocId: action.state?.bookAndDocId,
      };
    case BookActionEnum.FetchBookWithDocIdsByDocIdsFailure:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
    case BookActionEnum.AssociateBookWithDocId:
      return {
        ...state,
        loading: true,
      };
    case BookActionEnum.AssociateBookWithDocIdSuccess:
      return {
        ...state,
        loading: false,
        message: action.state?.message,
        updateDocumentBookCodeResult:
          action.state?.updateDocumentBookCodeResult,
        bookAndDocId:
          action.state?.updateDocumentBookCodeResult?.documentBookCode,
      };
    case BookActionEnum.AssociateBookWithDocIdFailure:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
      };
      case BookActionEnum.ClearBookResult:
        return {
          updateDocumentBookCodeResult: {} as IUpdateDocumentBookCodeResult
        }
    default:
      return state;
  }
};
